/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChildMemoDto } from '../../models/child-memo-dto';
import { CreateChildMemoDto } from '../../models/create-child-memo-dto';

export interface UserChildMemoControllerCreateMemo$Params {
  childId: string;
  centerId: string;
  teacherUserId?: string;
  guardianUserId?: string;
      body: CreateChildMemoDto
}

export function userChildMemoControllerCreateMemo(http: HttpClient, rootUrl: string, params: UserChildMemoControllerCreateMemo$Params, context?: HttpContext): Observable<StrictHttpResponse<ChildMemoDto>> {
  const rb = new RequestBuilder(rootUrl, userChildMemoControllerCreateMemo.PATH, 'post');
  if (params) {
    rb.query('childId', params.childId, {});
    rb.query('centerId', params.centerId, {});
    rb.query('teacherUserId', params.teacherUserId, {});
    rb.query('guardianUserId', params.guardianUserId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChildMemoDto>;
    })
  );
}

userChildMemoControllerCreateMemo.PATH = '/api/child-memo/user';
